document.addEventListener("turbo:load", () => {
  const sidebarWrapper = document.querySelector(".sidebar-wrapper");
  if (sidebarWrapper && window.OverlayScrollbarsGlobal?.OverlayScrollbars) {
    OverlayScrollbarsGlobal.OverlayScrollbars(sidebarWrapper, {
      scrollbars: {
        theme: "os-theme-light",
        autoHide: "leave",
        clickScroll: true,
      },
    });
  }
});
